import { sendHighlightEvent } from '@hotjar/webapp/domains/highlights/api';
import type { UIPosition } from '@hotjar/webapp/domains/highlights/api';
import { HighlightsEventType } from '@hotjar/webapp/domains/highlights/dto';
import { useCurrentSiteId } from '@hotjar/site';
import { event } from '@hotjar/webapp/tracking/tools/hotjar';
import type { HighlightsListItem } from '@hotjar/webapp/domains/highlights/model';
import { triggerDownload } from '../trigger-download';

const RECORDING_HIGHLIGHT_DOWNLOADED = 'recording_highlight_downloaded';

export function useDownloadRecordingHighlight(
  highlight: HighlightsListItem,
  uiPosition?: UIPosition,
): () => void {
  const currentSiteId = useCurrentSiteId();

  const downloadRecordingHighlight = () => {
    if (highlight) {
      if (highlight.type === 'recording') {
        if (highlight.metadata.videoUrl === null) {
          return;
        }

        triggerDownload(highlight.metadata.videoUrl, `clip_${highlight.id}.mp4`);

        if (currentSiteId) {
          sendHighlightEvent(
            currentSiteId,
            { highlightId: highlight.id, eventType: HighlightsEventType.HIGHLIGHT_DOWNLOADED },
            { uiPosition },
          );
        }

        event(RECORDING_HIGHLIGHT_DOWNLOADED);
      }
    }
  };

  return downloadRecordingHighlight;
}
